module.exports = __webpack_public_path__ + "media/images/banners/3-23f133fe583953a213be6814782d14b9.png";